import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { dialog, app, DialogSize, UrlDialogInfo } from "@microsoft/teams-js";

import { selectMessage, getScheduledMessagesList, getDraftMessagesList } from '../../actions';
import { getBaseUrl } from '../../configVariables';
import Overflow from '../OverFlow/scheduledMessageOverflow';
import './scheduledMessages.scss';
import { TFunction } from "i18next";
import { formatNumber } from '../../i18n';
import moment from 'moment';
import { Spinner, Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Text, Tooltip } from '@fluentui/react-components';
import { Checkmark24Regular, ErrorCircle24Regular, Dismiss24Regular, Chat24Regular } from '@fluentui/react-icons';

export interface ITaskInfo {
  title?: string;
  height?: number;
  width?: number;
  url?: string;
  card?: string;
  fallbackUrl?: string;
  completionBotId?: string;
}

export interface IMessage {
  id: string;
  title: string;
  sentDate: string;
  recipients: string;
  acknowledgements?: string;
  reactions?: string;
  responses?: string;
  scheduledDate: string;
  succeeded?: number;
  failed?: number;
  unknown?: number;
}

export interface IMessageProps extends WithTranslation {
  scheduledMessages: IMessage[];
  selectMessage?: any;
  getScheduledMessagesList?: any;
  getDraftMessagesList?: any;
  selectedMessage: any;
}

export interface IMessageState {
  message: IMessage[];
  loader: boolean;
}

class ScheduledMessages extends React.Component<IMessageProps, IMessageState> {
  readonly localize: TFunction;
  private interval: any;
  private isOpenTaskModuleAllowed: boolean;
  constructor(props: IMessageProps) {
    super(props);
    // initializeIcons();
    this.localize = this.props.t;
    this.isOpenTaskModuleAllowed = true;
    this.state = {
      message: this.props.scheduledMessages,
      loader: true,
    };
    this.escFunction = this.escFunction.bind(this);
  }

  public async componentDidMount() {
    await app.initialize();
    this.props.getScheduledMessagesList();
    document.addEventListener("keydown", this.escFunction, false);
    this.interval = setInterval(() => {
      this.props.getScheduledMessagesList();
    }, 60000);
  }

  public componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
    clearInterval(this.interval);
  }

  public componentWillReceiveProps(nextProps: any) {
    if (this.props !== nextProps) {
      this.setState({
        message: nextProps.scheduledMessages,
        loader: false
      });
    }
  }

  public render(): JSX.Element {
    if (this.state.loader) {
      return (
        <Spinner />
      );
    } else if (this.state.message.length === 0) {
      return (<div className="results">You have no scheduled messages.</div>);
    }
    else {
      return (
        <div className='scheduled-messages-container list'>
          <Table arial-label="Default table">
            <TableHeader>
              <TableRow>
                <TableHeaderCell key="title"><Text weight='bold' truncate={true} wrap={false}>{this.localize("TitleText")}</Text></TableHeaderCell>
                <TableHeaderCell key="status"></TableHeaderCell>
                <TableHeaderCell key="recipients"><Text weight='bold' truncate={true} wrap={false}>{this.localize("Recipients")}</Text></TableHeaderCell>
                <TableHeaderCell key="scheduled"><Text weight='bold' truncate={true} wrap={false}>{this.localize("Scheduled")}</Text></TableHeaderCell>
                <TableHeaderCell key="actions"></TableHeaderCell>

              </TableRow>
            </TableHeader>
            <TableBody>
              {this.state.message.map((item) => (
                <TableRow key={item.id} onClick={(e) => this.onRowClick(item)}>
                  <TableCell>
                    <div className='title-container'>
                      <Chat24Regular />
                      <Text truncate={true} wrap={false}>{item.title}</Text>
                    </div>
                  </TableCell>
                  <TableCell>{this.renderSendingText(item)}</TableCell>

                  <TableCell>
                    <div className='recipients-container' style={{ display: "flex" }}>
                      <Tooltip content={this.props.t("TooltipSuccess")} relationship="label">
                        <div className='tooltip-content'>
                          <Checkmark24Regular className='succeeded' />
                          <Text>{formatNumber(item.succeeded)}</Text>
                        </div>
                      </Tooltip>
                      <Tooltip content={this.props.t("TooltipFailure")} relationship="label">
                        <div className='tooltip-content'>
                          <Dismiss24Regular className='failed' />
                          <Text align='center'>{formatNumber(item.failed)}</Text>
                        </div>
                      </Tooltip>
                      {
                        item.unknown &&
                        <Tooltip content="Unknown" relationship="label">
                          <div className='tooltip-content'>
                            <ErrorCircle24Regular className='unknown' />
                            <span className="semiBold">{formatNumber(item.unknown)}</span>
                          </div>
                        </Tooltip>
                      }
                    </div>
                  </TableCell>

                  <TableCell>
                    <Text truncate={true} wrap={false}>{moment(item.scheduledDate).format("MM/DD/YYYY hh:mm A")}</Text>
                  </TableCell>
                  <TableCell>
                    <Overflow message={item} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
  }

  private renderSendingText = (message: any) => {
    var text = "";
    switch (message.status) {
      case "Queued":
        text = this.localize("Queued");
        break;
      case "SyncingRecipients":
        text = this.localize("SyncingRecipients");
        break;
      case "InstallingApp":
        text = this.localize("InstallingApp");
        break;
      case "Sending":
        let sentCount =
          (message.succeeded ? message.succeeded : 0) +
          (message.failed ? message.failed : 0) +
          (message.unknown ? message.unknown : 0);

        text = this.localize("SendingMessages", { "SentCount": formatNumber(sentCount), "TotalCount": formatNumber(message.totalMessageCount) });
        break;
      case "Sent":
      case "Failed":
        text = "";
    }

    return (<Text truncate={true} wrap={false} >{text}</Text>);
  }

  private onRowClick = (message: IMessage) => {
    let url = getBaseUrl() + "/viewstatus/" + message.id + "?locale={locale}";
    this.onOpenTaskModule(null, url, this.localize("ViewStatus"), message.id);
  }

  private escFunction = (event: any) => {
    if (event.keyCode === 27 || (event.key === "Escape")) {
      dialog.url.submit();
    }
  }

  public onOpenTaskModule = (event: any, url: string, title: string, id: string) => {
    if (this.isOpenTaskModuleAllowed) {
      this.isOpenTaskModuleAllowed = false;
      const dialogSize: DialogSize = {
        height: 660,
        width: 1000
      }
      const urlDialogInfo: UrlDialogInfo = {
        url: url,
        fallbackUrl: url,
        title: title,
        size: dialogSize
      }

      let submitHandler = (result: dialog.ISdkResponse) => {
        if (result.result === "editing") {
          this.isOpenTaskModuleAllowed = false;
          let editUrl = getBaseUrl() + "/newmessage/scheduled/" + id + "?locale={locale}";
          let urlDialogInfo: UrlDialogInfo = {
            url: editUrl,
            title: this.localize("EditMessage"),
            size: dialogSize,
            fallbackUrl: editUrl,
          }
          dialog.url.open(urlDialogInfo)
        }
        this.isOpenTaskModuleAllowed = true;
        this.props.getScheduledMessagesList().then(() => {
          this.props.getDraftMessagesList();
        })
      };

      dialog.url.open(urlDialogInfo, submitHandler);
    }
  }
}

const mapStateToProps = (state: any) => {
  return { scheduledMessages: state.scheduledMessages, selectedMessage: state.selectedMessage };
}

const scheduledMessagesWithTranslation = withTranslation()(ScheduledMessages);
export default connect(mapStateToProps, { selectMessage, getScheduledMessagesList, getDraftMessagesList })(scheduledMessagesWithTranslation);